
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schedule",
      function () {
        return require("private-next-pages/schedule.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schedule"])
      });
    }
  